export default __webpack_public_path__ + "static/media/Pickpocket's Belt of the Swift Return.033bfe85.jpg";